import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { SWAL } from '../../app-const';
import { AuthenticationService } from '../services/auth.service';
import { crmErrorMessage } from './crm-error-message';

export const errorInterceptor: HttpInterceptorFn = (request: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const translate = inject(TranslateService);
  const auth = inject(AuthenticationService);

  return next(request).pipe(
    catchError((err) => {
      if (err.status === 401) {
        if (request.url.includes('/manager-login') || request.url.includes('/login')) {
          return throwError(() => err);
        }
        if (auth.isLoggingOut) {
          return throwError(() => err);
        }
        auth.clearAuthenticationState(true);
        window.location.href = '/login';
        return throwError(() => ({ errorCode: 'SESSION_EXPIRED' }));
      }

      if (err.status === 403) {
        if (request.url.includes('/login')) {
          return throwError(() => err);
        }
        SWAL('error', translate.instant('SWAL.FORBIDDEN') || 'ليس لديك الصلاحية للقيام بهذا الإجراء', '');
        return throwError(() => err);
      }

      const payload = err?.error;
      // The CRM leads page asks the user to confirm a duplicate itself (PF-0129).
      if (err.status === 409 && payload?.error_code === 'CRM_DUPLICATE_LEAD') {
        return throwError(() => err);
      }
      // Platform CRM rule refusals carry a stable code with a translated message (PF-0137).
      const crmMessage = crmErrorMessage(payload, translate);
      if (crmMessage) {
        SWAL('error', crmMessage.title, crmMessage.text);
        // Confirmation subscribers honor this marker instead of replacing the translated dialog.
        return throwError(() => Object.assign(err, { errorCode: 'NO-ERROR' }));
      }
      const message = payload?.message || err?.message || 'حدث خطأ غير متوقع';

      if (payload?.errors && typeof payload.errors === 'object') {
        const errorList: string[] = [];
        for (const [key, value] of Object.entries(payload.errors)) {
          if (Array.isArray(value)) {
            errorList.push(...value.map(String));
          } else if (typeof value === 'string') {
            errorList.push(value);
          }
        }
        if (errorList.length > 0) {
          SWAL('error', errorList.join('\n'), '');
          return throwError(() => err);
        }
      }

      SWAL('error', message, '');
      return throwError(() => err);
    })
  );
};
